import { render, staticRenderFns } from "./ElemBMap.vue?vue&type=template&id=0aae454c&"
import script from "./ElemBMap.vue?vue&type=script&lang=js&"
export * from "./ElemBMap.vue?vue&type=script&lang=js&"
import style0 from "./ElemBMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports